import { i18nTranslationHelper } from '@/i18n'

export namespace Language {
  const t = {
    enums: i18nTranslationHelper.getTEnums
  }
  const [pt, es, en] = i18nTranslationHelper.getAllLanguages()

  export class Enum {
    static readonly PT = new Enum(pt, t.enums('language.PT.label'))
    static readonly ES = new Enum(es, t.enums('language.ES.label'))
    static readonly EN = new Enum(en, t.enums('language.EN.label'))

    private constructor(
      public readonly code: string,
      public readonly label: string
    ) {
      this.code = code
      this.label = label
    }
  }

  export const values = (): Enum[] => {
    return Object.values(Language.Enum)
  }
}
